import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const CloseIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "close",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M18 7L7 18M7 7L18 18",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	});
});
export { CloseIcon, CloseIcon as default };

//# sourceMappingURL=Close.js.map